import { render, staticRenderFns } from "./Accessories.vue?vue&type=template&id=51c96858&scoped=true"
import script from "./Accessories.vue?vue&type=script&lang=js"
export * from "./Accessories.vue?vue&type=script&lang=js"
import style0 from "./Accessories.vue?vue&type=style&index=0&id=51c96858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c96858",
  null
  
)

export default component.exports